// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_1b31b59a","outerContainer":"_608abfda","secondaryToolbar":"_833b941f","doorHangerRight":"b2d485d1","toolbarContainer":"_8b0415ac","toolbarViewerMiddle":"e4f7b46d","progressBar":"d145d77d","back-to-application":"_6949b2b9","root":"_96737cbc","disabled":"d98a49c4","btn":"_539a7975","endCall":"_7ff81da2","collapseBtn":"_532c6e7f","hideOnMobView":"_8f70b7ef"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/PublisherBtns/styles.styl
// module id = 5163
// module chunks = 39